import {
  Button,
  DatePicker,
  Flex,
  Icon,
  InputItem,
  List,
  NavBar,
  Picker,
  TextareaItem,
  Toast,
} from "antd-mobile";
import { useCallback, useEffect, useState } from "react";
import { bottomBtnStyle } from "..";
import instance from "../../../../util/axios";
import { formatRoundNumber } from "../util";
import { ProductInfo } from "./StepTwo";

export interface OrderCost {
  订单总额: string;
  正保币: string;
  学习卡: string;
  实收总额: string;
  销售业绩总额: string;
  支付方式: string[];
  支付方式名称: string;
  预计到款日期: any;
  收款单位: string[];
  收款单位名称: string;
  汇款单位: string;
  备注: string;
}

interface fiveProps {
  onCancel?: () => void;
  onOk?: (data: OrderCost) => void;
  productData: ProductInfo[];
  defaultValues?: OrderCost;
  defaultCompany?: string;
}
interface Option {
  label: string;
  value: string;
}

const isIPhone = new RegExp("\\biPhone\\b|\\biPod\\b", "i").test(
  window.navigator.userAgent
);
let moneyKeyboardWrapProps: object | undefined;
if (isIPhone) {
  moneyKeyboardWrapProps = {
    onTouchStart: (e: { preventDefault: () => any }) => e.preventDefault(),
  };
}

const StepFive = ({
  onCancel,
  onOk,
  productData,
  defaultValues,
  defaultCompany,
}: fiveProps) => {
  const [data, setData] = useState<OrderCost>({
    订单总额: "",
    正保币: "",
    学习卡: "",
    实收总额: "",
    销售业绩总额: "",
    支付方式: [],
    支付方式名称: "",
    预计到款日期: "",
    收款单位: [],
    收款单位名称: "",
    汇款单位: "",
    备注: "",
  });

  const [payDictionary, setPayDictionary] = useState<Option[]>([]);
  const [companyDictionary, setCompanyDictionary] = useState<Option[]>([]);

  useEffect(() => {
    instance
      .get(
        `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&dictionaryName=${encodeURI(
          "dict_正保产品订单_支付方式"
        )}
&key=&selectId=&filter=&colName=&isFull=true`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setPayDictionary(
            resp.data.Data.map((item: { uuid: any; name: any }) => ({
              value: item.uuid,
              label: item.name,
            }))
          );
        }
      });
    instance
      .get(
        `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&dictionaryName=${encodeURI(
          "dict_正保产品订单_到款单位"
        )}
&key=&selectId=&filter=&colName=&isFull=true`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setCompanyDictionary(
            resp.data.Data.map((item: { uuid: any; name: any }) => ({
              value: item.uuid,
              label: item.name,
            }))
          );
        }
      });
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (defaultValues && JSON.stringify(defaultValues) !== "{}") {
      setData(defaultValues);
    } else {
      let total: number = 0;
      let receivedTotal: number = 0;
      let salesTotal: number = 0;
      productData.forEach((item) => {
        total += parseFloat(item.subtotal || "0");
        receivedTotal += parseFloat(item.receipts || "0");
        salesTotal += parseFloat(item.sales || "0");
      });
      setData((prevState) => ({
        ...prevState,
        订单总额: total + "",
        正保币: "",
        学习卡: "",
        实收总额: receivedTotal + "",
        销售业绩总额: salesTotal + "",
        支付方式: [],
        支付方式名称: "",
        预计到款日期: "",
        收款单位: [],
        收款单位名称: "",
        汇款单位: defaultCompany || "",
        备注: "",
      }));
    }
  }, [defaultValues, productData, defaultCompany]);

  const onSave = useCallback(
    (form: OrderCost) => {
      if (form.正保币 && parseInt(form.正保币) % 20 !== 0) {
        Toast.info("请在正保币输入框中输入20的倍数", 1);
        return;
      } else if (form.支付方式.length === 0) {
        Toast.info("请选择支付方式", 1);
        return;
      } else if (!form.预计到款日期) {
        Toast.info("请选择预计到款日期", 1);
        return;
      } else if (form.收款单位.length === 0) {
        Toast.info("请选择收款单位", 1);
        return;
      } else if (!form.汇款单位) {
        Toast.info("请填写汇款单位", 1);
        return;
      }
      onOk?.(form);
    },
    [onOk]
  );

  return (
    <>
      <NavBar
        className="orderNavBar"
        icon={<Icon type="left" onClick={onCancel} />}>
        销售及内训订单
      </NavBar>
      <List className="picker-list mt45">
        <InputItem
          placeholder="0.00"
          extra="元"
          disabled={true}
          value={data.订单总额}
          onChange={(value) =>
            setData({
              ...data,
              订单总额: value,
            })
          }>
          订单总额
        </InputItem>
        <InputItem
          placeholder="请输入"
          value={data.正保币}
          type="money"
          moneyKeyboardWrapProps={moneyKeyboardWrapProps}
          onChange={(value) =>
            setData({
              ...data,
              正保币: formatRoundNumber(value),
            })
          }>
          正保币
        </InputItem>
        <InputItem
          placeholder="请输入"
          value={data.学习卡}
          type="money"
          moneyKeyboardWrapProps={moneyKeyboardWrapProps}
          onChange={(value) =>
            setData({
              ...data,
              学习卡: formatRoundNumber(value),
            })
          }>
          学习卡
        </InputItem>
        <InputItem
          placeholder="0.00"
          extra="元"
          disabled={true}
          value={data.实收总额}
          onChange={(value) =>
            setData({
              ...data,
              实收总额: value,
            })
          }>
          实收总额
        </InputItem>
        <InputItem
          placeholder="0.00"
          extra="元"
          disabled={true}
          value={data.销售业绩总额}
          onChange={(value) =>
            setData({
              ...data,
              销售业绩总额: value,
            })
          }>
          销售业绩总额
        </InputItem>
        <Picker
          data={payDictionary}
          cols={1}
          value={data.支付方式}
          onChange={(value: any) =>
            setData({
              ...data,
              支付方式: value,
              支付方式名称: payDictionary.find(
                (item) => item.value === value[0]
              )!?.label,
            })
          }>
          <List.Item arrow="horizontal">
            <span style={{ color: "red", marginRight: 5 }}>*</span>支付方式
          </List.Item>
        </Picker>
        <DatePicker
          mode="date"
          title="选择日期"
          value={data.预计到款日期}
          onChange={(value: any) =>
            setData({
              ...data,
              预计到款日期: value,
            })
          }>
          <List.Item arrow="horizontal">
            <span style={{ color: "red", marginRight: 5 }}>*</span>预计到款日期
          </List.Item>
        </DatePicker>
        <Picker
          data={companyDictionary}
          cols={1}
          value={data.收款单位}
          onChange={(value: any) =>
            setData({
              ...data,
              收款单位: value,
              收款单位名称: companyDictionary.find(
                (item) => item.value === value[0]
              )!?.label,
            })
          }>
          <List.Item arrow="horizontal">
            <span style={{ color: "red", marginRight: 5 }}>*</span>收款单位
          </List.Item>
        </Picker>
        <InputItem
          placeholder="请输入"
          value={data.汇款单位}
          onChange={(value) =>
            setData({
              ...data,
              汇款单位: value,
            })
          }>
          <span style={{ color: "red", marginRight: 5 }}>*</span>汇款单位
        </InputItem>
        <TextareaItem
          title="备注"
          autoHeight
          labelNumber={2}
          value={data.备注}
          onChange={(value) =>
            setData({
              ...data,
              备注: value || "",
            })
          }
        />
      </List>
      <Flex style={bottomBtnStyle}>
        <Flex.Item>
          <Button type="primary" onClick={onCancel}>
            上一步
          </Button>
        </Flex.Item>
        <Flex.Item>
          <Button type="primary" onClick={() => onSave?.(data)}>
            下一步
          </Button>
        </Flex.Item>
      </Flex>
    </>
  );
};

export default StepFive;
